import { createFileRoute } from "@tanstack/react-router";
import { all } from "better-all";
import { assert } from "utils";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { OrganizationExerciseDetailsPage } from "src/pages/OrganizationExerciseDetailsPage";
import { createOrganizationExercisesRepository } from "src/repositories/exercises/createOrganizationExercisesRepository";
import { exerciseCategoriesQueryOptions } from "src/state/exerciseCategories";
import { exerciseMovementPatternsQueryOptions } from "src/state/exerciseMovementPatterns";
import { exerciseMuscleGroupsQueryOptions } from "src/state/exerciseMuscleGroups";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/exercises/$exerciseId",
)({
  component: OrganizationExerciseDetailsPage,
  async loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        assert(params.exerciseId, "params.exerciseId is required");
        const exercisesRepository = createOrganizationExercisesRepository(
          organization.id,
        );
        const props = await all({
          async exercise() {
            return context.queryClient.query({
              ...exercisesRepository.detailOptions(params.exerciseId),
              staleTime: "static",
            });
          },
          async categories() {
            return context.queryClient.query({
              ...exerciseCategoriesQueryOptions(),
              staleTime: "static",
            });
          },
          async muscleGroups() {
            return context.queryClient.query({
              ...exerciseMuscleGroupsQueryOptions(),
              staleTime: "static",
            });
          },
          async movementPatterns() {
            return context.queryClient.query({
              ...exerciseMovementPatternsQueryOptions(),
              staleTime: "static",
            });
          },
        });

        return {
          data: { exercise: props.exercise },
          breadcrumb: {
            label: props.exercise.exercise.name,
            href: `/orgs/${params.slug}/exercises/${params.exerciseId}`,
            id: props.exercise.exercise.id,
          },
        };
      },
    );
  },
  head({ loaderData }) {
    return {
      meta: loaderData
        ? [{ title: `${loaderData.data.exercise.exercise.name} | sztama` }]
        : [],
    };
  },
});
